import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-full text-slate-800 bg-white" }
const _hoisted_2 = { class: "pb-32" }

import { watch, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAuth0 } from "@auth0/auth0-vue";
import { useAuth0Store } from "@/stores/Auth0Store";
import { useUserStore } from '@/stores/UserStore'
import { useFavoriteStore } from '@/stores/FavoriteStore';

import { Auth0User } from '@/types/Auth0';

import UserService from '@/services/UserService';

import MenuContainer from '@/components/MenuContainer.vue';
import OnboardingModal from '@/components/OnboardingModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { user: authedUser } = useAuth0();

const auth0Store = useAuth0Store();
const userStore = useUserStore();
const favoriteStore = useFavoriteStore();

const { user } = storeToRefs(userStore)
async function handleAuth0User(auth0User: Auth0User) {
	auth0Store.setUser(auth0User);
	if( !auth0User ) return;

	UserService.getByEmail(auth0User.email)
	.then((response) => {
		userStore.setUser(response.data)
		favoriteStore.fetchFavorites();
	})
}
const showOnboardingModal = computed(() => {
	return authedUser && user.value && !user.value.hasOnboarded;
})
watch(authedUser, (newUser) => {
	handleAuth0User(newUser);
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MenuContainer),
      (showOnboardingModal.value)
        ? (_openBlock(), _createBlock(OnboardingModal, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})